import { Component, Input, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ReceivedPoll } from 'src/app/models/ReceivedPoll';
import { Common } from 'src/app/shared/common';

@Component({
    selector: 'app-cse-category',
    templateUrl: 'cse-category.component.html',
    styleUrls: ['./cse-category.component.less', '../../../shared/common.less']
})

export class CseCategoryComponent implements OnInit {
    @Input() categoryTitle: string;
    @Input() value: string;
    @Input() note: string;

    constructor(private router: Router,
        private route: ActivatedRoute,
        public common: Common
    ) { }

    ngOnInit(): void {

    }
}